
import React from 'react';

interface SkipLinkProps {
  targetId: string;
  className?: string;
  text?: string;
}

export function SkipLink({ targetId, className, text = "Aller au contenu principal" }: SkipLinkProps) {
  return (
    <a 
      href={`#${targetId}`}
      className={`sr-only focus:not-sr-only focus:absolute focus:p-4 focus:bg-background focus:text-foreground focus:z-50 focus:top-4 focus:left-4 focus:outline-none focus:ring-2 focus:ring-primary ${className}`}
    >
      {text}
    </a>
  );
}

export default SkipLink;
